import { render } from "./site-button.vue?vue&type=template&id=02679da8"
import script from "./site-button.vue?vue&type=script&lang=js"
export * from "./site-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__